import React, { useEffect, useState } from 'react';
import { workoutExecution } from '../../services/api';
import Sheet from './Sheet';
import { describeSet, formatKg, trackingKind } from './playerLogic';

// O histórico REAL do sócio neste exercício (treinos concluídos): sessões, séries, carga máxima, volume e quantas vezes o fez.
// Nada aqui é estimado a partir de outros dados: sem sessões, diz que ainda não há histórico.

const fmtDate = (iso) => { try { return new Date(iso).toLocaleDateString('pt-PT', { day: 'numeric', month: 'short', year: 'numeric' }); } catch { return ''; } };
const signed = (n) => `${n > 0 ? '+' : n < 0 ? '−' : ''}${formatKg(Math.abs(n))}`;

export default function ExerciseHistorySheet({ open, exercise, onClose, api = workoutExecution }) {
  const libraryId = exercise?.executedLibraryExerciseId ?? exercise?.libraryExerciseId ?? exercise?.library?.id ?? null;
  const [state, setState] = useState({ loading: false, error: null, data: null });

  useEffect(() => {
    if (!open || !libraryId) return undefined;
    let alive = true;
    setState({ loading: true, error: null, data: null });
    api.exerciseHistory(libraryId, 8)
      .then((res) => { if (alive) setState({ loading: false, error: null, data: res.data }); })
      .catch(() => { if (alive) setState({ loading: false, error: 'Não foi possível carregar o histórico.', data: null }); });
    return () => { alive = false; };
  }, [open, libraryId, api]);

  const data = state.data;
  const kind = trackingKind(exercise?.trackingType);

  return (
    <Sheet open={open} onClose={onClose} title="O seu histórico" subtitle={exercise?.name} testId="exercise-history">
      {!libraryId ? <p className="wp-note">Este exercício não está ligado à biblioteca, por isso não há histórico.</p> : null}
      {state.loading ? <p className="wp-note" role="status">A carregar…</p> : null}
      {state.error ? <p className="wp-error" role="alert">{state.error}</p> : null}

      {data && data.sessions.length === 0 ? (
        <p className="wp-note" data-testid="history-empty">Ainda não tem treinos concluídos com este exercício. Depois do primeiro, aparece aqui.</p>
      ) : null}

      {data && data.sessions.length > 0 ? (
        <div data-testid="history-body">
          <p className="wp-note">
            {data.sessions30Days} vez{data.sessions30Days === 1 ? '' : 'es'} nos últimos 30 dias · {data.sessions90Days} nos últimos 90.
            {data.topWeightChangeKg != null ? ` Carga máxima: ${signed(data.topWeightChangeKg)} kg desde a primeira sessão listada.` : ''}
            {data.lastVolumeChangeKg != null ? ` Volume da última sessão: ${signed(data.lastVolumeChangeKg)} kg face à anterior.` : ''}
          </p>
          <ol className="wp-list-ex">
            {data.sessions.map((s) => (
              <li key={`${s.workoutExecutionId}-${s.performedAt}`} className="wp-ex-row" data-testid="history-session">
                <span className="wp-ex-text">
                  <span className="wp-ex-name">{fmtDate(s.performedAt)}</span>
                  <span className="wp-ex-meta">
                    {s.sets.map((set) => describeSet(set, exercise?.trackingType)).join('  ·  ')}{kind.usesTime ? '' : ' reps'}
                  </span>
                  {s.topWeightKg ? (
                    <span className="wp-ex-meta">
                      máx. {formatKg(s.topWeightKg)} kg · volume {Math.round(s.volumeKg).toLocaleString('pt-PT')} kg
                      {s.estimatedOneRepMaxKg ? ` · 1RM estimado ${formatKg(s.estimatedOneRepMaxKg)} kg` : ''}
                    </span>
                  ) : null}
                </span>
              </li>
            ))}
          </ol>
          <p className="wp-note">O 1RM é uma estimativa (fórmula de Epley) a partir da melhor série: serve de referência, não de teste.</p>
        </div>
      ) : null}
    </Sheet>
  );
}
